import {
  dangerColor,
  successColor
} from "../../eclipse.js";
import {primaryColor, primaryTextColor, gradientFromColor, gradientToColor, buttonHoverFocusTextColor, linkHoverFocusTextColor, controlLabelColor, disabledCardBackgroundColor, buttonTextColor} from "../../../../style.scss"

const themeStyle = {
  buttonRadius: {
    fontWeight: '600',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: primaryColor,
      color: buttonHoverFocusTextColor
    },
    '&:focus': {
      backgroundColor: primaryColor,
      color: buttonHoverFocusTextColor
    }
  },
  fileUploadButton: {
    padding: '1.125rem 2.25rem',
    background: primaryColor,
    margin: '0.5em auto',
    cursor: 'pointer',
    width: 'calc(100% - 6em)',
    color: buttonTextColor,
    textAlign: 'center',
    display: 'inline-block',
  },
  title: {
    fontWeight: '400',
    fontSize: '1em',
    lineHeight: '1.6em',
    color: primaryTextColor,
  },
  linkColor: {
    color: primaryColor,
    fontWeight: '600',
    cursor: 'pointer',
    '&:hover': {
      color: linkHoverFocusTextColor,
    },
    '&:focus': {
      color: linkHoverFocusTextColor,
    }
  },
  formControl: {
    margin: "1em 0.5em",
  },
  button: {
    margin: "0",
  },
  regularFontSize: {
    fontSize: '0.9em',
  },
  textCenter: {
    textAlign: 'center'
  },
  textRight: {
    textAlign: 'right'
  },
  screenCenterPrimaryIcon: {
    fontSize: '5em',
    color: primaryColor,
    textAlign: 'center',
    width: '100%',
    margin: '0.5em 0 0'
  },
  screenCenterDangerIcon: {
    fontSize: '5em',
    color: dangerColor[0],
    textAlign: 'center',
    width: '100%',
    margin: '0.5em 0 0'
  },
  labelText: {
    fontSize: '0.9em',
    color: controlLabelColor
  },
  gradientCurve: {
    background: `linear-gradient(163.24deg, ${gradientFromColor} 31.54%, ${gradientToColor} 88.12%)`
  },
  iconSuccess: {
    color: successColor[0],
    paddingTop: '0.1em',
    fontSize: '2em'
  },
  iconDanger: {
    color: dangerColor[0],
    paddingTop: '0.1em',
    fontSize: '2em'
  },
  disabledCard: {
    backgroundColor: disabledCardBackgroundColor,
    cursor: "not-allowed"
  }
};

export default themeStyle;
